import React from 'react';

import { SupplierForm } from '../SupplierForm';

export const SupplierCreateForm: React.FC = () => {
  return <SupplierForm mode="create" />;
};
